import React, { useState, useEffect } from "react";
import { Box, Text } from 'grommet';
import AgDataTable from '../common/AgDataTable'

import { gql, useQuery } from '@apollo/client';
import { useCompanyFix, useCompanyConn } from '../../utils/company'
import { useConnection } from '../../utils/connection'

import struct from 'python-struct'
import uuidParse from 'uuid-parse'
import { HealthServiceDataViewStatus } from '../health2/details/HealthStatusService'


const CURRENT_SESSION_DATA_CONNECTION = gql`
query ($env: String!) {
    sessionOCNoCompanyView(where: {environmentName: {_eq: $env}}) {
        nodeIp
        nodeName
        status
        id:connectionId
      }
}
`

const CURRENT_SESSION_DATA_FIX = gql`
query ($env: String!) {
    sessionFixView(where: {environmentName: {_eq: $env}}) {
        nodeIp
        nodeName
        status
        id: fixSessionId
        clientCompId
      }
}
`

const CURRENT_SESSION_DATA_EDGE = gql`
query ($env: String!) {
    sessionUserView(where: {environmentName: {_eq: $env}}) {
        nodeIp
        nodeName
        id: userId
        userEmail
        clientType
        sessionId
      }
}
`

const ServiceHistoryFindNow = ({ sessionDataPast, sessionType, envName }) => {

    // Depending on SessionType use different query
    let queryToUse = CURRENT_SESSION_DATA_CONNECTION
    if (sessionType === 'connections') {
        queryToUse = CURRENT_SESSION_DATA_CONNECTION
    } else if (sessionType === 'fixsessions') {
        queryToUse = CURRENT_SESSION_DATA_FIX
    } else if (sessionType === 'users') {
        queryToUse = CURRENT_SESSION_DATA_EDGE
    }

    const sessionDataNow = useQuery(queryToUse, {
        variables: { env: envName },
    })

    const companyLookupFix = useCompanyFix(envName)
    const connectionLookup = useConnection(envName)
    const companyLookup = useCompanyConn(envName)

    // Table Columns
    const tab_col_init = [
        {
            field: "id",
            headerName: "Id",
            minWidth: 150,
        },
        {
            field: "nodeName",
            headerName: "Current Node",
            minWidth: 150,

        },
        {
            field: "nodeIp",
            headerName: "Node Ip",
            minWidth: 150,
        },
        {
            field: "status",
            headerName: "Current Status",
            minWidth: 250,
            suppressSizeToFit: true,
            cellStyle: function (params) {
                if (params.value === 'up') {
                    return { color: 'black', backgroundColor: 'white' };
                } else if (params.value.toLowerCase() === 'exchange scheduled down' || params.value.indexOf("Empty order routing parameter") > -1 || params.value.indexOf("No users mapped to connection") > -1) {
                    return { color: 'white', backgroundColor: '#A6A6A6' };
                } else if (params.node.data.newConnection === 'YES') {
                    return { color: 'white', backgroundColor: '#A6A6A6' };
                } else {
                    return { color: 'white', backgroundColor: '#B4130B' };
                }
            },
            sort: 'asc'
        },
    ]

    const [tab_col, setTab_col] = useState(tab_col_init);
    const [tab_data, setTab_data] = useState([]);

    useEffect(() => {

        let tab_col_temp = tab_col_init

        // Show Known Connection IDs in other places
        let tab_data_temp = []
        if (!sessionDataNow.loading && sessionDataPast) {
            if (sessionType === 'connections' && connectionLookup && companyLookup) {
                sessionDataPast.forEach(session => {
                    if (sessionDataNow.data.sessionOCNoCompanyView.filter(e => e.id === session.id).length > 0) {
                        let foundSession = sessionDataNow.data.sessionOCNoCompanyView.filter(e => e.id === session.id)[0]

                        tab_data_temp.push({
                            "nodeIp": foundSession.nodeIp,
                            "nodeName": foundSession.nodeName,
                            "status": foundSession.status,
                            "id": session.id,
                            "uniqueId": session.id,
                            "connectionName": connectionLookup[session.id] ? connectionLookup[session.id].name : '-',
                            "companyName": companyLookup[session.id] ? companyLookup[session.id].name : '-'
                        })

                    } else {
                        tab_data_temp.push({
                            "nodeIp": "",
                            "nodeName": "",
                            "status": "NOT FOUND",
                            "id": session.id,
                            "uniqueId": session.id,
                            "connectionName": connectionLookup[session.id] ? connectionLookup[session.id].name : '-',
                            "companyName": companyLookup[session.id] ? companyLookup[session.id].name : '-'
                        })
                    }
                })

                // add connectionName to col
                tab_col_temp.push(
                    {
                        field: "connectionName",
                        headerName: "Connection Name",
                        minWidth: 150,
                    },
                    {
                        field: "companyName",
                        headerName: "Company",
                        minWidth: 150,
                    },
                )

            } else if (sessionType === 'fixsessions' && companyLookupFix) {
                sessionDataPast.forEach(session => {
                    if (sessionDataNow.data.sessionFixView.filter(e => e.id === session.id).length > 0) {
                        let foundSession = sessionDataNow.data.sessionFixView.filter(e => e.id === session.id)[0]
                        //foundSession.uniqueId = session.id
                        //foundSession.companyName = companyLookupFix[session.id] && companyLookupFix[session.id].name ? companyLookupFix[session.id].name : '-'
                        tab_data_temp.push({
                            "companyName": companyLookupFix[session.id] && companyLookupFix[session.id].name ? companyLookupFix[session.id].name : '-',
                            "nodeIp": foundSession.nodeIp,
                            "nodeName": foundSession.nodeName,
                            "status": foundSession.status,
                            "id": session.id,
                            "uniqueId": session.id,
                            "clientCompId": foundSession.clientCompId
                        })
                    } else {
                        tab_data_temp.push({
                            "companyName": companyLookupFix[session.id] && companyLookupFix[session.id].name ? companyLookupFix[session.id].name : '-',
                            "nodeIp": "",
                            "nodeName": "",
                            "status": "NOT FOUND",
                            "id": session.id,
                            "uniqueId": session.id,
                            "clientCompId": session.clientCompId
                        })
                    }
                })

                // add compid to col
                tab_col_temp.push(
                    {
                        field: "companyName",
                        minWidth: 150,
                        headerName: "Company Name",

                    },
                    {
                        field: "clientCompId",
                        minWidth: 150,
                        headerName: "clientCompId"
                    }
                )
            } else if (sessionType === 'users') {
                sessionDataPast.forEach(session => {
                    if (sessionDataNow.data.sessionUserView.filter(e => (e.id) === (session.user_id.toString())).length > 0) {
                        let foundSession = sessionDataNow.data.sessionUserView.filter(e => (e.id) === (session.user_id.toString()))[0]

                        //foundSession.uniqueId = session.user_id
                        //foundSession.status = "up"

                        let sessionId = session.session_id
                        let b = struct.pack("<QQ", [sessionId.hi, sessionId.lo])
                        sessionId = uuidParse.unparse(b)

                        //foundSession.sessionId = sessionId
                        //tab_data.push(foundSession)

                        tab_data_temp.push({
                            "nodeIp": foundSession.nodeIp,
                            "nodeName": foundSession.nodeName,
                            "status": "up",
                            "id": foundSession.user_id,
                            "uniqueId": foundSession.user_id,
                            "userEmail": foundSession.user_email,
                            "clientType": foundSession.clientType,
                            "sessionId": sessionId
                        })

                    } else {

                        let sessionId = session.session_id
                        let b = struct.pack("<QQ", [sessionId.hi, sessionId.lo])
                        sessionId = uuidParse.unparse(b)

                        tab_data_temp.push({
                            "nodeIp": "",
                            "nodeName": "",
                            "status": "NOT FOUND",
                            "id": session.user_id,
                            "uniqueId": session.user_id,
                            "userEmail": session.user_email,
                            "clientType": session.clientType,
                            "sessionId": sessionId
                        })
                    }
                })
                tab_col_temp.push(
                    {
                        field: "userEmail",
                        headerName: "Email",
                        minWidth: 150,

                    },
                    {
                        field: "clientType",
                        headerName: "Client Type",
                        minWidth: 150,
                    },
                    {
                        field: "sessionId",
                        headerName: "Session ID",
                        minWidth: 150,
                    }
                )
            }
            setTab_data(tab_data_temp)
            setTab_col(tab_col_temp)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [sessionDataNow.loading, sessionDataNow.data, sessionDataPast, companyLookupFix, connectionLookup, companyLookup, sessionType])

    return (
        <Box>
            {tab_data.length > 0 &&
                <Box border="top" margin={{ top: "small", left: "xsmall", right: "xsmall" }} fill="horizontal">
                    <Box direction="row">
                        <Text margin={{ top: "8px", bottom: "8px" }} size="small" color="dark-3" weight="bold">Sessions</Text>
                        <HealthServiceDataViewStatus tab_data={tab_data.map(function (item) { return item["status"] })} />
                    </Box>
                    <AgDataTable
                        tab_col={tab_col}
                        tab_data={tab_data}
                        tableName={"ServiceHistoryFindNow" + sessionType}
                        countTitle="Sessions"
                        tableHeight={700}
                    />
                </Box>
            }
        </Box>
    )
}

export default ServiceHistoryFindNow
